import { render, staticRenderFns } from "./add1.vue?vue&type=template&id=cc4d782e&scoped=true&"
import script from "./add1.vue?vue&type=script&lang=js&"
export * from "./add1.vue?vue&type=script&lang=js&"
import style0 from "./add1.vue?vue&type=style&index=0&id=cc4d782e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4d782e",
  null
  
)

export default component.exports